<template>
  <div class="view view-subpage inner-width-narrow">
    <section>
      <article>
        <h1>{{ title }}</h1>
        <div v-html="bodyHtml"></div>
        <aside v-html="asideHtml"></aside>
      </article>
    </section>
  </div>
</template>


<script>
  import { baseCmsUrl, baseCmsNode } from '../../config';

export default {
  name: 'subpage',
  props: ['subpage'],
  data() {
    return {
      title: '',
      bodyHtml: '',
      asideHtml: '',
    }
  },
  methods: {
    getContent(subpage) {

      this.$http.get(`${baseCmsUrl}path/${baseCmsNode}${subpage}`).then((response) => {
        this.title = response.data.fields.title.text;
        this.bodyHtml = response.data.fields.body.content;
        console.log('1: ', response.data.fields);
        if ('aside' in response.data.fields == true) {
          this.asideHtml = response.data.fields.aside.content;
        } else {
          this.asideHtml = '';
        }
        return;
      });
    },
  },
  watch: {
    '$route'(to, from) {
      this.getContent(to.params.subpage);
    }
  },
  mounted() {
    this.getContent(this.$route.params.subpage);
  }
} 
</script>
